export default {
  role: state => {
    return state.role
  },
  isUser: state => {
    return state.role === 'user' || state.role === 'wall_user' || state.role === ''
  },
  isReceptionManager: state => {
    return state.role === 'reception_manager'
  },
  isReception: state => {
    return state.role === 'reception'
  },
  isAuthenticated: state => {
    return state.role !== ''
  }
}
